import React, { useState, useEffect, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Import Gallery Images (Double-check these paths!!)
import ayurved1 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.25.10.jpeg';  // Example paths - VERIFY!
import ayurved2 from '../assets/Spa/sp.jpeg';
import ayurved3 from '../assets/Spa/day_d1.jpg';
import ayurved4 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.25.38.jpeg';
import ayurved5 from '../assets/Spa/WhatsApp Image 2025-08-14 at 21.26.15.jpeg';
import ayurved6 from '../assets/Spa/Untitled+design+(20).png';
import ayurved7 from '../assets/Spa/Shiro-Abyanga-Head-massages.webp';
import ayurved8 from '../assets/Spa/WhatsApp Image 2025-08-14 at 15.19.09.jpeg';


import villa1 from '../assets/Home/WhatsApp Image 2025-08-14 at 14.28.12.jpeg';
import villa2 from '../assets/Home/WhatsApp Image 2025-08-14 at 10.16.15.jpeg';
import villa3 from '../assets/Home/s10.jpeg';
import villa4 from '../assets/Home/WhatsApp Image 2025-08-14 at 14.28.30.jpeg';
import villa5 from '../assets/Home/s15.jpeg';
import villa6 from '../assets/Home/s16.jpeg';
import villa7 from '../assets/Home/WhatsApp Image 2025-08-14 at 10.16.16.jpeg';
import villa8 from '../assets/Home/WhatsApp Image 2025-08-14 at 14.28.32.jpeg';



import tour1 from '../assets/Drive Ceylon/yala/istockphoto-1150626798-612x612.jpg';
import tour2 from '../assets/Drive Ceylon/yala/LK710A2062-06-E.webp';
import tour3 from '../assets/Drive Ceylon/benthota/kande-viharaya-ancient-temple.webp';
import tour4 from '../assets/Drive Ceylon/benthota/istockphoto-1429231332-612x612.jpg';
import tour5 from '../assets/Drive Ceylon/turtle/istockphoto-1170317702-612x612.jpg';
import tour6 from '../assets/Drive Ceylon/Galle/istockphoto-472387838-612x612.jpg';



const Gallery = () => {
    const [category, setCategory] = useState('All');
    const [displayedImages, setDisplayedImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const images = useMemo(() => ({
        All: [ayurved1, ayurved2, ayurved3, ayurved4, ayurved5, ayurved6, ayurved7, villa1, villa2, villa3, villa4, villa5, villa6, villa7, tour1, tour2, tour3, tour4, villa8, tour5, tour6, ayurved8],
        Ayurved: [ayurved1, ayurved2, ayurved3, ayurved4, ayurved5, ayurved6, ayurved7, ayurved8,],
        Villa: [villa1, villa2, villa3, villa4, villa5, villa6, villa7, villa8,],
        Tours: [tour1, tour2, tour3, tour4, tour5, tour6],
    }), []); // Empty dependency array - images is stable

    useEffect(() => {
        setDisplayedImages(images[category] || []); // Handle potential undefined category
    }, [category, images]); // category MUST be here, images SHOULD be here

    const handleImageClick = (img) => {
        setIsLoading(true);
        setSelectedImage(img);
        setShowModal(true);

        // Simulate loading of large image
        const image = new Image();
        image.src = img;
        image.onload = () => {
            setIsLoading(false);
        };
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage(null);
        setIsLoading(false);
    };

    return (
        <section className="container my-5">
            <h2 className="text-center fw-bold text-dark mb-4 display-4">Our Gallery</h2>

            <div className="d-flex justify-content-center mb-4 flex-wrap">
                {['All', 'Ayurved', 'Villa', 'Tours'].map((btn) => (
                    <button
                        key={btn}
                        className={`btn mx-2 my-1 ${category === btn ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => setCategory(btn)}
                    >
                        {btn}
                    </button>
                ))}
            </div>

            <div className="row">
                {displayedImages.map((img, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4">
                            <img
                                src={img}
                                alt={`Gallery ${index + 1}`}
                                className="img-fluid rounded"
                                style={{ objectFit: 'cover', height: '250px', width: '100%', cursor: 'pointer' }}
                                onClick={() => handleImageClick(img)}
                                loading="lazy"
                            />
                        </div>
                    </div>
                ))}
            </div>

            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Body className="p-0 position-relative">
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <img
                            src={selectedImage}
                            alt="Enlarged Gallery"
                            className="img-fluid rounded"
                            style={{ width: '100%' }}
                        />
                    )}
                    <Button
                        variant="secondary"
                        onClick={handleCloseModal}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            zIndex: 1000,
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        &times;
                    </Button>
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default Gallery;